export default __webpack_public_path__ + "static/media/warning--other-danger--g1.3188ed01.png";